<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-0 only-desktop"
      >
        <div class="w-100 h-100 d-lg-flex bg-login">
          <div
            class="h-100 d-lg-flex flex-column align-items-start justify-content-between p-3"
          >
            <logo-and-text height="150" dark />
            <h1 class="login-light-title">
              Seja bem-vindo à maior plataforma de planejadores financeiros
              autônomos do Brasil!
            </h1>
          </div>
        </div>
      </b-col>

      <!-- <div class="expired-logo mb-3 d-flex">
        <div class="logo-cont"><logo /></div>

        <div><logo-text /></div>
      </div> -->
      <b-col
        cols="12"
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 h-100"
      >
        <b-card class="shadow-sm">
          <p class="text-center mb-4">
            Enviamos para o seu e-mail um código de autorização de 6 (seis)
            dígitos. <br> Informe o código recebido abaixo para acessar o Oráculo:
          </p>

          <b-form @submit.prevent="" class="mb-3">
            <b-form-group label="" label-for="otp-code">
              <div class="d-flex justify-content-center gap-2 mb-3">
                <input
                  v-for="index in 6"
                  :key="index"
                  :ref="'digit' + index"
                  v-model="code[index - 1]"
                  class="form-control text-center otp-input"
                  type="text"
                  maxlength="1"
                  @input="onInput($event, index)"
                  @keydown="onKeydown($event, index)"
                />
              </div>
            </b-form-group>

            <div class="mt-4">
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="!isCodeComplete"
              >
                Acessar Oráculo
              </b-button>

              <b-button
                variant="link"
                block
                :disabled="!resendEnabled"
                @click="onResendCode"
                class="mt-3"
              >
                {{ resendButtonLabel }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import * as types from "../store/types";
import Logo from "@core/layouts/components/Logo.vue";
import LogoText from "@core/layouts/components/LogoText.vue";
import LogoAndText from "@core/layouts/components/LogoAndText.vue";

export default {
  components: {
    Logo,
    LogoText,
    LogoAndText,
  },
  data() {
    return {
      code: Array(6).fill(""),
      resendEnabled: false,
      countdown: 60,
    };
  },
  computed: {
    isCodeComplete() {
      return this.code.every((digit) => digit !== "" && /^\d$/.test(digit));
    },
    resendButtonLabel() {
      if (this.resendEnabled) {
        return "Enviar novo código";
      }
      return `Reenviar código (${this.countdown}s)`;
    },
  },
  mounted() {
    this.startCountdown();
    this.$nextTick(() => {
      this.$refs.digit1[0].focus();
    });
  },
  methods: {
    ...mapActions({
      // verifyCode: types.VERIFY_AUTH_CODE,
      // requestNewCode: types.REQUEST_NEW_AUTH_CODE,
    }),

    onInput(e, index) {
      const value = e.target.value;
      if (!/^\d?$/.test(value)) {
        this.code[index - 1] = "";
        return;
      }

      this.code[index - 1] = value;

      if (value && index < 6) {
        this.$refs["digit" + (index + 1)][0].focus();
      }
    },

    onKeydown(e, index) {
      if (e.key === "Backspace" && !this.code[index - 1] && index > 1) {
        this.$refs["digit" + (index - 1)][0].focus();
      }
    },

    startCountdown() {
      this.countdown = 60;
      this.resendEnabled = false;

      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.resendEnabled = true;
          clearInterval(timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";
.bg-login {
  background-image: url("https://futurogfp-assets.s3.sa-east-1.amazonaws.com/futuro_background.webp");
  background-size: cover;
}
.login-light-title {
  color: #fff !important;
  margin-bottom: 2rem;
}
@media (max-width: 1024px) {
  .only-desktop {
    display: none;
  }
}

.expired-logo {
  text-align: center;
  margin-top: 2rem;
  z-index: 1000;

  .logo-cont {
    margin-right: 0.5rem;
  }
}

.otp-input {
  width: 40px;
  height: 48px;
  font-size: 1.2rem;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #ced4da;
}

.otp-input:focus {
  border-color: #f26237;
  box-shadow: 0 0 0 0.2rem rgba(242, 98, 55, 0.25);
}

.gap-2 {
  gap: 0.5rem;
}

.shadow-sm {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.text-muted {
  color: #6c757d;
}
</style>
